import { AutomatedBreakType } from '@sdk/settings/types';

export const getDefaultBreakTypeSelection = ({
  canTakeMealBreak,
  canTakeRestBreak
}: {
  canTakeMealBreak: boolean;
  canTakeRestBreak: boolean;
}) => {
  if (canTakeMealBreak) return AutomatedBreakType.meal;
  if (canTakeRestBreak) return AutomatedBreakType.rest;

  return null;
};
